import { ReactNode } from 'react';
import classes from './AceGenericFieldLayout.module.css';
import { Icon } from '@blueprintjs/core';
import { classNames } from '../../utils/classNames';

interface AceGenericFieldLayoutProps {
  label?: ReactNode;
  error?: ReactNode;
  warning?: ReactNode;
  inputElement: ReactNode;
  valueElement: ReactNode;
  editable?: boolean;
  vertical?: boolean;
}

export const AceGenericFieldLayout: React.FC<AceGenericFieldLayoutProps> = ({
  label,
  error,
  warning,
  inputElement,
  valueElement,
  editable,
  vertical,
}) => {
  return (
    <div
      className={classNames(
        label ? classes.withLabel : classes.withoutLabel,
        label ? 'aceFieldLayoutWithLabel' : 'aceFieldLayoutWithoutLabel',
        vertical ? classes.vertical : undefined
      )}
    >
      {label && <label className={classes.defaultTextStyles}>{label}</label>}
      <div className={classes.defaultTextStyles}>
        {editable ? inputElement : valueElement}
      </div>
      {!vertical && label && error && <div />}
      {error && (
        <div
          className={classNames(
            classes.defaultTextStyles,
            classes.errorContainer
          )}
        >
          <Icon icon="warning-sign" size={12} />
          <p>{error}</p>
        </div>
      )}
      {!vertical && label && warning && <div />}
      {warning && (
        <div
          className={classNames(
            classes.defaultTextStyles,
            classes.warningContainer
          )}
        >
          <Icon icon="warning-sign" size={12} />
          <p>{warning}</p>
        </div>
      )}
    </div>
  );
};
